import { component } from 'picoapp';

import choozy from 'utils/choozy';
// Utils
import { ariaExpandToggle } from 'utils/node';
import { dispatch } from 'utils/theme';

export default component((node) => {
  const { grid, wrapper, colorName, option: options = [] } = choozy(node);
  const { showMoreBtn: showMoreBtns = [] } = choozy(node, true);

  const defaultName = colorName.textContent;

  let timeout = null;

  node.addEventListener('click', (e) => {
    if (!showMoreBtns.includes(e.target)) return;

    wrapper.style.maxHeight = `${wrapper.offsetHeight}px`;
    node.classList.add('open');
    wrapper.style.maxHeight = `${grid.offsetHeight + 1}px`;

    [].concat(showMoreBtns).forEach(ariaExpandToggle);

    dispatch('pdp-show-more-color-options');
  });

  [].concat(options).forEach((el) => {
    el.addEventListener('mouseenter', () => {
      clearTimeout(timeout);

      colorName.textContent = el.dataset.option;
    });
    el.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        colorName.textContent = defaultName;
      }, 100);
    });
  });
});
